module.exports = __webpack_public_path__ + "static/media/icon_fb.6ad60d5d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/icon_fb.svg
// module id = 41
// module chunks = 0